import { put, all } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "rdx/modules/financials/messages";
import formatList from "./util/formatPayoutsList";

function* distributePayoutsRequest() {
  const { success, data, error } = yield* makeRequest.post("/payouts/distribute", {});

  if (success && data) {
    yield all([
      put(actions.setPayoutsList(formatList(data))),
      put(
        actions.newSuccessEvent({
          message: messages.SUCCESS_DISTRIBUTING_PAYOUTS,
        }),
      ),
    ]);
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_DISTRIBUTING_PAYOUTS,
    });
  }

  return null;
}

export default distributePayoutsRequest;
